module.exports = __webpack_public_path__ + "media/images/emblems/Vaulruz-coat_of_arms-b9cdb00eebe1b5df571899d1fa81b195.svg";